import { html } from 'lit';

export const iconPlus = html`
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.7207 0.875V4.25H9.0957C9.49414 4.25 9.8457 4.60156 9.8457 5C9.8457 5.42188 9.49414 5.75 9.0957 5.75H5.7207V9.125C5.7207 9.54688 5.36914 9.875 4.9707 9.875C4.54883 9.875 4.2207 9.54688 4.2207 9.125V5.75H0.845703C0.423828 5.75 0.0957031 5.42188 0.0957031 5C0.0957031 4.60156 0.423828 4.25 0.845703 4.25H4.2207V0.875C4.2207 0.476562 4.54883 0.125 4.9707 0.125C5.36914 0.125 5.7207 0.476562 5.7207 0.875Z"
    />
  </svg>
`;
